<script setup>
definePage({
  meta: {
    action: 'write',
    subject: 'source-user',
    navActiveLink: 'sources-users',
  },
})


import { getProjectId } from "@/utils/cdms"
import { useSnackBar } from '@/utils/stores/snackbar'
import SearchUserDialog from '@/views/sources/users/searchUserDialog.vue'

const router = useRouter()

const snackbarStore = useSnackBar()

if(await isLockedProject()) {router.back()}

const showSearchDialog = ref(false)
const siteSelects = ref([])
const roles = ref([])

const data = reactive({
  projectId: getProjectId(),
  startDate: "",
  endDate: "",
  role: "",
  site: "",
})

const {  data: roleData,  error, execute: fetchDatas } = await useApi(createUrl('/management/roles/all', {
  query: {
  },
}))

if (error.value) {
  console.log(error.value)
} else {
  roles.value = roleData.value.splice(1)

  roles.value = (Array.isArray(roleData.value) ? roleData.value : [])

  // .slice(1)  // ⬅️ 현재 역할이 잘릴 수 있으니 제거. 특정 역할을 숨기려면 name으로 filter 하세요.
  // 예: .filter(r => r.name !== 'Super Admin')
    .map(r => ({
      // 타입 정리: id는 숫자로
      id: Number(r.id),

      // 표시용 타이틀(실명 우선, 없으면 name)
      title: r.realName ?? r.name ?? '',

      // 필요하면 원본도 보관
      name: r.name,
      realName: r.realName,
    }))

  // --- 사용자 로드 --- 
 

  // roleId 정규화: "2" -> 2, "시험책임자/담당자" -> 해당 id, 없으면 null
  function normalizeRoleId(v, list) {
    if (v == null) return null

    // 1) 숫자/숫자문자 우선 처리
    const n = Number(v)
    if (!Number.isNaN(n)) return n


    // 2) 라벨로 넘어온 경우(realName/name/title) 매칭
    const hit = (list || []).find(
      x => x.realName === v || x.name === v || x.title === v,
    )

  
    return hit ? hit.id : null
  }

  // 사용자 데이터에 적용
  data.roleId = normalizeRoleId(data.roleId, roles.value)
}

const {
  data: siteData,
  execute: fetchSubjects,
} = await useApi(createUrl('/sources/sites/all', {
  query: {
    projectId: getProjectId(),
  },
}))

siteSelects.value = siteData.value

const refForm = ref(null)

const searchUser = () => {
  showSearchDialog.value = true
}

const selectUser = user => {
  data.userId = user.id
  data.email = user.email
  data.name = user.name
  data.roleName = user.role_name ?? user.roleName ?? ''
  data.siteName = user.site_name ?? user.siteName ?? ''
}

const saveUser = async () => {
  const validate = await refForm?.value.validate()
  if(!validate.valid) return

  const result = await $api(`/sources/users`, { method: 'POST',
    body: { projectId: getProjectId(), data } })

  snackbarStore.showSnackBar("Successfully Saved!")

  router.push({ name: `sources-users` })
}
</script>

<template>
  <SearchUserDialog
    :show="showSearchDialog"
    @update:show="showSearchDialog=false"
    @select-item="selectUser"
  />
  <VRow>
    <VCol
      cols="12"
      sm="12"
      md="9"
      lg="7"
      order="1"
      order-lg="1"
    >
      <VCard :title="$t('Add User')">
        <!-- <VCardTitle></VCardTitle> -->
        <VCardText class="mt-4">
          <VForm
            ref="refForm"
            @submit.prevent="() => {}"
          >
            <VRow>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 User Name -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="email"
                    >{{ $t('User') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="email"
                      v-model="data.email"
                      persistent-placeholder
                      readonly
                      :rules="[requiredValidator]"
                    >
                      <template #append>
                        <VBtn @click="searchUser">
                          {{ $t('Search') }}
                        </VBtn>
                      </template>
                    </apptextfield>
                  </VCol>
                  <!--
                    <VCol
                    cols="12"
                    md="3"
                    >

                    </VCol>
                  -->
                </VRow>
              </VCol>
              <VCol
                v-if="data.email"
                cols="12"
              >
                <VRow no-gutters>
                  <!-- 👉 User Name -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="name"
                    >{{ $t('User Name') }}<span style="color:red">*</span></label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      id="name"
                      v-model="data.name"
                      persistent-placeholder
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 Start Date -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="startDate"
                    >{{ $t('Start Date') }}</label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppDateTimePicker
                      v-model="data.startDate"
                      append-inner-icon="tabler-calendar-event"
                    />
                  </VCol>
                </VRow>
              </VCol>
              <VCol cols="12">
                <VRow no-gutters>
                  <!-- 👉 End Date -->
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label
                      class="v-label text-body-2 text-high-emphasis"
                      for="endDate"
                    >{{ $t('End Date') }}</label>
                  </VCol>

                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppDateTimePicker
                      v-model="data.endDate"
                      append-inner-icon="tabler-calendar-event"
                    />
                  </VCol>
                </VRow>
              </VCol>
              <!-- Role (읽기전용 - 관리 페이지에서 지정) -->
              <VCol
                v-if="data.email"
                cols="12"
              >
                <VRow no-gutters>
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label class="v-label text-body-2 text-high-emphasis">
                      {{ $t('Role') }}
                    </label>
                  </VCol>
                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      :model-value="data.roleName"
                      persistent-placeholder
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>

              <!-- Site (읽기전용 - 관리 페이지에서 지정) -->
              <VCol
                v-if="data.email"
                cols="12"
              >
                <VRow no-gutters>
                  <VCol
                    cols="12"
                    md="3"
                    class="d-flex align-items-center"
                  >
                    <label class="v-label text-body-2 text-high-emphasis">
                      {{ $t('Site Name') }}
                    </label>
                  </VCol>
                  <VCol
                    cols="12"
                    md="9"
                  >
                    <AppTextField
                      :model-value="data.siteName"
                      persistent-placeholder
                      disabled
                    />
                  </VCol>
                </VRow>
              </VCol>

              <!-- 👉 submit and reset button -->
              <VCol
                offset-md="3"
                cols="12"
                md="9"
                class="d-flex gap-4"
              >
                <VBtn
                  type="submit"
                  @click="saveUser"
                >
                  {{ $t('Save') }}
                </VBtn>
                <VBtn
                  color="secondary"
                  variant="tonal"
                  @click="$router.back()"
                >
                  {{ $t('Cancel') }}
                </VBtn>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </vcard>
    </VCol>
  </VRow>
</template>
